<template>
  <b-container fluid class="mt-2 px-1 px-sm-3 pb-3 equipment-list-page">
    <b-row>
      <b-col cols="">
        <b-row>
          <b-col cols="">
            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
              <h2 class="text-left mb-0">{{ pageTitle }}</h2>
              <div class="d-flex d-sm-none justify-content-between justify-content-sm-center flex-wrap">
                <b-button @click="allowAddEquipment = true" v-if="allowCreateEquipment"
                  class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                  variant="primary">
                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                  <p class="mb-0 ml-2 text-white">{{ addRecordLabel }}</p>
                </b-button>
                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                  v-if="allowImportEquipments || allowExportEquipments || (allowUpdateEquipment && selectedRows.length)">
                  <template slot="button-content">
                    <b-icon class="dots" icon="three-dots"></b-icon>
                  </template>
                  <b-dropdown-item-button v-if="allowExportEquipments" @click="downloadExcel"
                    :class="allowImportEquipments || allowUpdateEquipment && selectedRows.length ? 'mb-2' : ''">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.exportCsv') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="allowImportEquipments"
                    :class="allowUpdateEquipment && selectedRows.length ? 'mb-2' : 'mb-0'"
                    @click="$bvModal.show('modal-bulk-upload')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.importCsv') }}</p>
                  </b-dropdown-item-button>

                  <b-dropdown-item-button class="mb-2" v-if="(allowUpdateEquipment && selectedRows.length)"
                    @click="$bvModal.show('modal-add-bulk-tags')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.addTags') }}</p>
                  </b-dropdown-item-button>
                   <b-dropdown-item-button class="mb-2" v-if="(allowUpdateEquipment && selectedRows.length)"
                    @click="$bvModal.show('modal-bulk-division-update')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.setDivision') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="allowUpdateEquipment && selectedRows.length" @click="addDocument">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.addDocument') }}</p>
                  </b-dropdown-item-button>
                </b-dropdown>
                  <b-dropdown-item-button v-if="allowUpdateEquipment && selectedRows.length && this.equipmentType !== 'Inactive'"
                    @click="showDeactivateModal = true">
                    <p class="text_secondary cursor-pointer mb-0 f-14 -ml-3px">{{ equipmentType !== 'Inactive' ? $t('equipmentListPage.deactivate') : $t('equipmentListPage.activate') }}</p>
                  </b-dropdown-item-button>
              </div>
              <div class="d-none d-sm-flex justify-content-between justify-content-sm-center flex-wrap">
                <b-button @click="allowAddEquipment = true" v-if="allowCreateEquipment"
                  class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                  variant="primary">
                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                  <p class="mb-0 ml-2 text-white">{{ addRecordLabel }}</p>
                </b-button>
                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                  v-if="allowImportEquipments || allowExportEquipments || (allowUpdateEquipment && selectedRows.length)">
                  <template slot="button-content">
                    <b-icon class="dots" icon="three-dots"></b-icon>
                  </template>
                  <b-dropdown-item-button v-if="allowExportEquipments" @click="downloadExcel"
                    :class="allowImportEquipments || allowUpdateEquipment && selectedRows.length ? 'mb-2' : ''">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.exportCsv') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button v-if="allowImportEquipments"
                    :class="allowUpdateEquipment && selectedRows.length ? 'mb-2' : 'mb-0'"
                    @click="$bvModal.show('modal-bulk-upload')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.importCsv') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="(allowUpdateEquipment && selectedRows.length)"
                    @click="$bvModal.show('modal-add-bulk-tags')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.addTags') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="(allowUpdateEquipment && selectedRows.length)"
                    @click="$bvModal.show('modal-bulk-division-update')">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.setDivision') }}</p>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button class="mb-2" v-if="allowUpdateEquipment && selectedRows.length" @click="addDocument">
                    <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.addDocument') }}</p>
                  </b-dropdown-item-button>
                   <b-dropdown-item-button v-if="allowUpdateEquipment && selectedRows.length"
                    @click="showDeactivateModal = true">
                    <p class="text_secondary cursor-pointer mb-0 f-14 -ml-3px"> {{ equipmentType !== 'Inactive' ? $t('equipmentListPage.deactivate') : $t('equipmentListPage.activate') }}</p>
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="data-table team-data-table table-custom-border">
              <div class="bg-white rounded">
                <div v-if="contentLoading" class="d-flex align-items-center px-3 py-3">
                  <b-skeleton v-for="n in 4" :key="`view-tab-skeleton-${n}`" width="80px" height="26px"
                    class="mr-3 mb-0"></b-skeleton>
                </div>
                <v-tabs v-else ref="viewsTabs" :key="`tabs-${tableViews.length}`"
                  class="team-tabs mb-0" v-model="activeViewIndex" show-arrows>
                   <v-tab v-for="(view, index) in tableViews" :class="index === lastDefaultViewIndex ? 'with-border' : ''"
                    :key="`${viewKey(view)}-${index}`">
                    {{ view.name }} <span
                      v-if="view.name.toLowerCase() === 'active' || view.name.toLowerCase() === 'inactive'"
                      class="f-12 ml-1">{{ view.name.toLowerCase() === 'active' ? `(${activeCount})` :
                        `(${inactiveCount})` }}</span>
                  </v-tab>
                  <v-tab key="add-view" @click.stop="openAddView()">
                    <span class="add-view-plus mr-1">+</span> {{ $t('equipmentListPage.addView') }}
                  </v-tab>
                </v-tabs>
              </div>
              <div class="bg-white pt-3 pt-sm-4 rounded" v-if="contentLoading">
                <div class="table_row">
                  <div class="pb-4" style="height: calc(100vh - 230px); overflow: hidden;">
                    <b-skeleton-table :rows="17" :columns="7"
                      :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                  </div>
                </div>
              </div>
              <div class="bg-white pt-3 pt-sm-4 rounded" v-else>
                <div class="table_row">
                  <div class="equipment-border filter-box">
                    <div class="d-flex mb-4 px-3 px-sm-4">
                      <b-form-group class="text-left label font-weight-normal search-field mb-0">
                        <b-input-group class="username-input-field">
                          <b-form-input type="text" :placeholder="$t('equipmentListPage.search')" v-model="filterFields.search_field"
                            class="unit f-12" @keyup.enter="getEquipmentData()"></b-form-input>
                          <b-input-group-append>
                            <b-button variant="primary" @click="getEquipmentData()">
                              <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>

                      <div class="ml-auto d-none d-sm-flex align-items-center flex-wrap">
                        <button class="btn btn-filter-section" v-if="!isDefaultActiveView" @click="deleteView()">
                          <div class="d-flex align-items-center">
                            <svg width="19" height="20" viewBox="0 0 19 20" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 5.15704H17.6139" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path
                                d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path
                                d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M7.23175 9.3065V14.8466" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M11.385 9.3065V14.8466" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                            <p class="mb-0 ml-2">{{ $t('equipmentListPage.delete') }}</p>
                          </div>
                        </button>
                        <div class="position-relative" :class="!isDefaultActiveView ? 'ml-2' : ''">
                          <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                            {{ activeFiltersCount }}
                          </div>
                          <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                            <div class="d-flex align-items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-sliders-horizontal w-4 h-4"
                                data-id="element-964">
                                <line x1="21" x2="14" y1="4" y2="4"></line>
                                <line x1="10" x2="3" y1="4" y2="4"></line>
                                <line x1="21" x2="12" y1="12" y2="12"></line>
                                <line x1="8" x2="3" y1="12" y2="12"></line>
                                <line x1="21" x2="16" y1="20" y2="20"></line>
                                <line x1="12" x2="3" y1="20" y2="20"></line>
                                <line x1="14" x2="14" y1="2" y2="6"></line>
                                <line x1="8" x2="8" y1="10" y2="14"></line>
                                <line x1="16" x2="16" y1="18" y2="22"></line>
                              </svg>
                              <p class="mb-0 ml-2">{{ $t('equipmentListPage.filters') }}</p>
                            </div>
                          </button>
                        </div>
                        <div class="table-columns-section ml-2 mt-0" @click="showColumns = true">
                          <button class="btn btn-table-columns-section">
                            <div class="d-flex align-items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-columns2 w-4 h-4" data-id="element-961">
                                <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                                <path d="M12 3v18"></path>
                              </svg>
                              <p class="mb-0 ml-2">{{ $t('equipmentListPage.columns') }}</p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <b-table v-if="tableViews.length" ref="tableRef" class="mt-2" responsive :fields="visibleFields" :items="items" hover
                    :sticky-header="'calc(100vh - 330px)'" :current-page="currentPage" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" :no-local-sorting="true" :busy.sync="isBusy" :show-empty="emptyTable"
                    selectable select-mode="multi" no-select-on-click @row-selected="onRowSelected">
                    <template #head(selected)="">
                      <b-form-checkbox class="pl-0 w-fit-content" @change="selectRows($event)" v-model="allRowsSelected">
                      </b-form-checkbox>
                    </template>
                    <template #cell(selected)="data">
                      <b-form-checkbox class="pl-0 w-fit-content" @change="checked(data.index, data.rowSelected)"
                        v-model="data.rowSelected">
                      </b-form-checkbox>
                    </template>
                    <template #cell(unit_no)="data" v-if="allowUpdateEquipment || allowViewEquipment">
                      <p class="text_primary mb-0 cursor-pointer" @click="setEquipmentData(data.item.id)">
                        {{ data.value }}
                      </p>
                    </template>
                    <template #cell(integration)="data">
                         <b-img v-if="data.value" width="20" height="20" :src="require('@/assets/Check.svg')"></b-img> 
                        <b-img v-else width="20" height="20" :src="require('@/assets/Close.svg')"></b-img> 
                      </template>
                     <template #cell(value)="data">
                      <p>
                        {{ data.value !== '-' ? data.value.toLocaleString("en-US", { style: "currency", currency: "USD" }) : '-' }}
                      </p>
                    </template>
                    <template #cell(notes)="data">
                      <div v-if="data.value">
                        <span v-html="`${data.value}`" class="notes-item cursor-pointer"
                          @click="showNotesSection(data.item.id)"></span>
                      </div>
                      <span v-else>-</span>
                    </template>
                    <template #cell(tags)="data">
                      <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0] }}</div>
                        <v-app>
                          <v-tooltip bottom v-if="data.value.length > 1">
                            <template #activator="{ on, attrs }">
                              <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                            </template> <span v-html="data.value.slice(1).join('<br>')"></span>
                          </v-tooltip>
                        </v-app>
                      </div>
                      <p class="mb-0" v-else>-</p>
                    </template>
                    <template #cell(num_docs)="data">
                      <span :style='data.item.color' class="docs-circle">{{ data.value }}</span>
                    </template>
                    <template #cell(status)="data">
                      <b-button class="btn export pe-none d-flex justify-content-center align-items-center"
                        :variant="data.item.status === 'Active' ? 'primary-status' : data.item.status === 'Assigned' ? 'success-status' : 'secondary-status'">
                        <p class="mb-0">{{ statusDisplay(data.value) }}</p>
                      </b-button>
                    </template>
                  </b-table>
                  <div class="entries-pagination px-0 px-sm-2">
                    <div class="d-flex align-items-center flex-wrap">
                      <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                      </div>
                      <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                      <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                          aria-controls="my-table"></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Import CSV Modal  -->
    <b-modal id="modal-bulk-upload" centered hide-footer @shown="resetField" no-close-on-backdrop :body-class="'p-4'"
      no-close-on-esc>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('equipmentListPage.importCsvModalTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('equipmentListPage.closeModal') }}
        </b-button>
      </template>
      <div class="d-block text-center">
        <b-row class="import-excel-modal mx-0">
          <b-col cols="12" class="px-0">
            <div class="upload-btn-wrapper mt-0">
              <b-img :src="require('@/assets/drop.svg')"></b-img>
              <button class="foo" v-if="!fileName">
                {{ $t('equipmentListPage.dropDocument') }}
              </button>
              <button v-else class="foo">{{ fileName }}</button>
              <input ref="docFile" type="file" name="docFile" @change="handleFileUpload" accept=".csv" />
              <p v-if="errors && errors.document" class="field-error">
                {{ errors.document }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" class="text-left cursor-pointer mt-2 pt-1 pl-1">
            <a class="download-sample-file" href="/files/sample-vehicles.csv" download="sample-vehicles.csv"
              v-if="$route.name === 'Vehicle'">
              <b-img :src="require('@/assets/sample-file.svg')"></b-img>
              {{ $t('equipmentListPage.downloadSampleFile') }}
            </a>
            <a class="download-sample-file" href="/files/sample-trailers.csv" download="sample-trailers.csv" v-else>
              <b-img :src="require('@/assets/sample-file.svg')"></b-img>
              {{ $t('equipmentListPage.downloadSampleFile') }}
            </a>
          </b-col>
        </b-row>
      </div>
      <div class="text-right modal-footer border-0 p-0">
        <b-button class="mx-0 mr-3 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload')"
          variant="secondary">{{ $t('equipmentListPage.cancel') }}</b-button>
        <b-button class="mx-0 mb-0 h-40px w-100px" variant="primary" @click="bulkUploadEquipment">{{ $t('equipmentListPage.save') }}</b-button>
      </div>
    </b-modal>
    <!-- Bulk Upload Errors Modal -->
    <b-modal id="modal-bulk-upload-errors" centered hide-footer size="md" no-close-on-backdrop>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('equipmentListPage.csvImportErrors') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('equipmentListPage.closeModal') }}
        </b-button>
      </template>
      <div class="bulk-upload-errors-container">
        <p v-if="bulkUploadSummary" class="mb-3 font-weight-bold">{{ bulkUploadSummary }}</p>
        <div class="errors-list" style="max-height: 400px; overflow-y: auto;">
          <div v-for="(error, index) in bulkUploadErrors" :key="index" class="error-item mb-2 p-2" style="background: #fff3f3; border-left: 3px solid #dc3545; border-radius: 4px;">
            <p class="mb-0"><strong>{{ error.row }}:</strong> {{ error.message }}</p>
          </div>
        </div>
      </div>
      <div class="text-right modal-footer border-0 p-0 mt-3">
        <b-button class="mx-0 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload-errors')" variant="primary">{{ $t('equipmentListPage.close') }}</b-button>
      </div>
    </b-modal>
    <AddEquipment :allowAddEquipment="allowAddEquipment" :states="states" :options="options"
      @close="allowAddEquipment = false" @getNewData="getEquipmentNewData($event)" />
    <TableColumns :defaultView="isDefaultActiveView" :showColumns="showColumns" :fields="availableColumns"
      :viewColumns="tableViews.length > 0 ? tableViews[activeViewIndex] : []"
      @getUpdatedFieldsList="getUpdatedFieldsList($event)" @updateFields="updateFields($event)"
      @resetTableFields="resetTableFields()" @resetData="showColumns = false" />
    <EditEquipment :equipmentID="equipmentID" :states="states" :options="options" @updateEquipment="resetEquipmentList"
      @updateData="getEquipmentData()" @resetEquipment="equipmentID = ''; setNotesSection = false"
      :setNotesSection="setNotesSection" />
    <AddTags :ids="selectedRows.map((data) => data.id)" v-if="selectedRows.length"
      @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false" @updateTags="getEquipmentData()"
      :type="'equipment'" />
      <BulkDivisionUpdate :ids="selectedRows.map((data) => data.id)"
      @close="$refs.tableRef.clearSelected(); selectedRows = []" v-if="selectedRows.length"
      @updateDivision="getEquipmentData()" type="'equipment'"/>
    <DeleteModal v-if="showDeactivateModal" @confirm="changeEquipmentStatusItem($event)"
      :message="$t('equipmentListPage.confirmStatusChange', { action: equipmentType === 'Inactive' ? $t('equipmentListPage.actionActivate') : $t('equipmentListPage.actionDeactivate') })" :removeMessage="equipmentType === 'Inactive' ? $t('equipmentListPage.activate') : $t('equipmentListPage.deactivate')" />
    <b-modal id="modal-bulk-equipment-docs" centered hide-footer @shown="resetBulkDocFields" no-close-on-backdrop
      size="lg" :body-class="'px-3 pt-2 overflow-preview-auto'" no-close-on-esc
      :footer-class="'d-block border-0 pt-0 pb-3 m-0'" :header-class="'align-items-center'" scrollable>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('equipmentListPage.documentModalTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('equipmentListPage.closeModal') }}
        </b-button>
        <b-dropdown id="dropdown-preview" text="text" class="load-dropdown mt-0" v-if="docFileName">
          <template slot="button-content">
            <b-icon class="dots" icon="three-dots"></b-icon>
          </template>
          <b-dropdown-item-button @click="removeFile()">
            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('equipmentListPage.replaceDoc') }}</p>
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
      <div class="d-block text-center">
        <b-row>
          <b-col lg="4" sm="12">
            <div class="text-left mb-3">
              <label for="modal-datepicker" class="state">{{ $t('equipmentListPage.dateLabel') }}</label>
              <date-picker v-model="documentData.date" :formatter="momentFormat" :range-separator="' - '"
                @clear="documentData.date = ''" :placeholder="$t('equipmentListPage.selectDate')" class="date-picker-custom"
                :teleport="'body'"></date-picker>
              <p v-if="docErrors && docErrors.date" class="field-error">
                {{ docErrors.date[0] }}
              </p>
            </div>
            <div class="text-left mb-3">
              <label for="modal-expiry-date" class="state">{{ $t('equipmentListPage.expiryDateLabel') }}</label>
              <date-picker v-model="documentData.expiry_date" :formatter="momentFormat" :range-separator="' - '"
                @clear="documentData.expiry_date = ''" :placeholder="$t('equipmentListPage.selectDate')" class="date-picker-custom"
                :teleport="'body'"></date-picker>
              <p v-if="docErrors && docErrors.expiry_date" class="field-error">
                {{ docErrors.expiry_date[0] }}
              </p>
            </div>
            <div class="text-left mb-3">
              <label class="state">{{ $t('equipmentListPage.typeLabel') }}</label>
              <b-form-select class="f-12" :options="getDotOptions" v-model="documentData.doc_type"
                @change="setDocDescription($event)">
              </b-form-select>
              <p v-if="docErrors && docErrors.doc_type" class="field-error">
                {{ docErrors.doc_type[0] }}
              </p>
            </div>
            <div class="text-left mb-3">
              <label class="state">{{ $t('equipmentListPage.descriptionLabel') }}</label>
              <b-form-textarea id="textarea" :placeholder="$t('equipmentListPage.descriptionPlaceholder')" rows="3"
                v-model="documentData.description"></b-form-textarea>
              <p v-if="docErrors && errors.docErrors" class="field-error pb-4">
                {{ docErrors.description[0] }}
              </p>
            </div>
          </b-col>
          <b-col lg="8" sm="12">
            <div class="upload-btn-wrapper" v-if="!docFileName">
              <b-img :src="require('@/assets/drop.svg')"></b-img>
              <button v-if="!docFileName" class="foo">
                {{ $t('equipmentListPage.dropDocument') }}
              </button>
              <button v-else class="foo">{{ docFileName }}</button>

              <input ref="bulkDocFile" type="file" name="bulkDocFile" v-on:change="handleBulkFileUpload"
                accept=".pdf, .png, .jpg, .jpeg" />
              <p v-if="errors && errors.document" class="field-error">
                {{ errors.document[0] }}
              </p>
            </div>
            <div v-else>
              <div class="review-media-section" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                <iframe class="w-100 h-100 border-0" v-if="mediaType === 'pdf'" :src="media"></iframe>
                <div v-else>
                  <div id="panzoom-element" ref="panzoomElement">
                    <img :src="media" class="w-100 h-100 img-section" />
                  </div>
                  <div class="d-flex align-items-center justify-content-center zoom-section">
                    <b-icon @click="zoom(1)" icon="zoom-in" style="fill:white; cursor: pointer;"></b-icon>
                    <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out" style="fill:white;cursor: pointer;"></b-icon>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="text-right modal-footer border-0 p-0 mt-4">
        <b-button class="mx-0 h-40px w-100px m-0 mr-3" @click="$bvModal.hide('modal-bulk-equipment-docs'); panzoom = null"
          variant="secondary">{{ $t('equipmentListPage.cancel') }}</b-button>
        <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendDocumentData">{{ $t('equipmentListPage.save') }}</b-button>
      </div>
    </b-modal>
    <b-modal id="modal-filter" centered no-close-on-backdrop no-close-on-esc
            :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block p-3 m-0'"
            :header-class="'align-items-center'" scrollable>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('equipmentListPage.filtersModalTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('equipmentListPage.closeModal') }}
        </b-button>
      </template>
      <div class="body">
        <b-form-group :label="$t('equipmentListPage.filterDocs')" v-if="checkTableField('num_docs')" class="text-left select_arrow label mb-3">
          <b-form-select type="text" class="input f-12" :options="docFilterOptions" v-model="filterFields.doc" @change="getEquipmentData()"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('equipmentListPage.filterTags')" class="text-left w-equipment-box mb-3">
          <v-select multiple class="f-12 bg-grey" :options="allTags" :reduce="(option) => option.id"
            v-model="filterFields.tags" @input="getEquipmentData()" />
        </b-form-group>
        <b-form-group :label="$t('equipmentListPage.filterDivision')" class="text-left w-equipment-box mb-3">
          <v-select multiple class="f-12 bg-grey" :options="allDivisions" :reduce="(option) => option.id"
            v-model="filterFields.division" @input="getEquipmentData()" />
        </b-form-group>
        <b-form-group :label="$t('equipmentListPage.filterStatus')" class="text-left select_arrow label w-equipment-box mb-3"
          v-if="equipmentType === 'Active,Assigned'">
          <b-form-select type="text" class="input f-12" :options="translatedStatusOptions" v-model="filterFields.status"
            @change="getEquipmentData()"></b-form-select>
        </b-form-group>
        <template v-for="field in equipmentCustomFields">
          <b-form-group v-if="field.field_type === 'text' || field.field_type === 'number' || field.field_type === 'date'" :key="`cf-${field.id}`"
            :label="field.name" class="text-left label mb-3">
            <b-form-input class="input f-12" :type="field.field_type === 'number' ? 'number' : field.field_type === 'date' ? 'date' : 'text'"
              v-model="filterFields[`cf_${field.id}`]"
              @keyup.enter="getEquipmentData()" @change="getEquipmentData()" />
          </b-form-group>
          <b-form-group v-else-if="field.field_type === 'select' || field.field_type === 'multi_select'"
            :key="`cf-${field.id}`" :label="field.name" class="text-left w-equipment-box mb-3">
            <v-select :options="field.options" class="f-12 bg-grey"
             :multiple="field.field_type === 'multi_select'" :reduce="(option) => option"
              v-model="filterFields[`cf_${field.id}`]"
              @input="getEquipmentData()" />
          </b-form-group>
        </template>
      </div>
      <template #modal-footer="">
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
          <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
            @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('equipmentListPage.reset') }}</b-button>
          <b-button class="mx-0 h-40px w-100px m-0 m-0" :variant="isDefaultActiveView ? 'secondary' : 'primary'" block
            @click="onFilterModalSave()">{{ isDefaultActiveView ? $t('equipmentListPage.close') : $t('equipmentListPage.save') }}</b-button>
        </div>
      </template>
    </b-modal>
    <DeleteModal v-if="showDeleteViewModal" @confirm="confirmDeleteView($event)" :message="$t('equipmentListPage.confirmDeleteView')"/>
    <AddTableViewModal :table="tableKey" :seedColumns="currentColumnsState" :seedFilters="currentFiltersQuery"
      @created="onViewCreated" @cancel="activeViewIndex = 0"/>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import * as moment from "moment-timezone";
import EditEquipment from "@/components/Equipment/EditEquipment.vue";
import AddEquipment from "@/components/Equipment/AddEquipment.vue";
import AddTags from "@/components/Shared/AddTags.vue";
import BulkDivisionUpdate from "@/components/driver/BulkDivisionUpdate.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import TableColumns from "@/components/Shared/TableColumns.vue";
import AddTableViewModal from "@/components/Shared/TableViews/AddTableViewModal.vue";
import Panzoom from '@panzoom/panzoom'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {checkDescriptionLength} from '../../services/helper'
export default {
  name: "equipment-list",
  components: {
    vSelect,
    EditEquipment,
    AddEquipment,
    DeleteModal,
    AddTags,
    DatePicker,
    TableColumns,
    BulkDivisionUpdate,
    AddTableViewModal
  },
  data() {
    return {
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format('ll') : ''
        },
        parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
      },
      showColumns: false,
      checkDescriptionLength,
      states: [],
      equipmentType: 'Active,Assigned',
      countries: [],
      allRowsSelected: false,
      document: null,
      activeCount: 0,
      inactiveCount: 0,
      allowAddEquipment: false,
      rows: 1,
      emptyTable: false,
      positionText: "",
      equipmentID: null,
      sortBy: undefined,
      sortDesc: undefined,
      showDeactivateModal: false,
      isBusy: false,
      isTableMounted: false,
      fileName: null,
      docFileName: null,
      perPage: 25,
      currentPage: 1,
      widthBox: 100,
      items: [],
      bulkUploadErrors: [],
      bulkUploadSummary: '',
      errors: {
        document: null,
      },
      filterFields: {
        search_field: '',
        doc: '',
        tags: [],
        division: [],
        status: 'Active,Assigned'
      },
      equipmentDispatchGroups: [],
      allTags: [],
      equipmentCustomFields: [],
      tableViews: [],
      activeViewIndex: 0,
      availableColumns: [],
      activeViewFiltersRaw: '',
      showDeleteViewModal: false,
      pageOptions: [
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],
      newEquipment: {
        unit_no: null,
        subtype: null,
        year: null,
        make: null,
        vin_no: null,
        plate_no: null,
        state: {
          id: 54,
          country: 1,
        },
      },
      selectedRows: [],
      fields: [],
      selected: null,
      options: [
        {
          value: "",
          text: "",
        },
        {
          value: "Vehicle",
          text: "Vehicle",
        },
        {
          value: "Trailer",
          text: "Trailer",
        },
      ],
      typeOptions: [
        {
          value: "",
          text: "",
        },
        {
          value: "Vehicle",
          text: "Vehicle",
        },
        {
          value: "Trailer",
          text: "Trailer",
        },
      ],
      media: null,
      mediaType: null,
      panzoom: null,
      mediaID: null,
      documentData: {
        object_id: null,
        date: null,
        type: null,
        expiry_date: "",
        document: null,
        description: null,
        driver: true,
        public: false,
        doc_type: ""
      },
      docErrors: {
        date: null,
        type: null,
        document: null,
        description: null,
      },

      setNotesSection: false
    };
  },
  computed: {
    ...mapGetters([
      "allEquipments",
      "dispatchGroups",
      "licenseInventory",
      "company",
      "allCountries",
      "tags",
      "userCompany",
      "rolePermissions",
      "user",
      "docTypeItems",
      "divisions"
    ]),
    allDivisions() {
      return this.divisions.map((item) => {
        return {
          id: item.id,
          label: item.division,
        }
      })
    },
    pageTitle() {
      return this.$route.name === 'Vehicle' ? this.$t('equipmentListPage.titleVehicles') : this.$t('equipmentListPage.titleTrailers');
    },
    addRecordLabel() {
      return this.$route.name === 'Vehicle' ? this.$t('equipmentListPage.addVehicle') : this.$t('equipmentListPage.addTrailer');
    },
    docFilterOptions() {
      return [
        { value: '', text: '' },
        { value: 'True', text: this.$t('equipmentListPage.yes') },
        { value: 'False', text: this.$t('equipmentListPage.no') },
      ];
    },
    translatedStatusOptions() {
      return [
        { value: 'Active,Assigned', text: '' },
        { value: 'Active', text: this.$t('equipmentListPage.statusActive') },
        { value: 'Assigned', text: this.$t('equipmentListPage.statusAssigned') },
      ];
    },
    allowViewEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][0].allow
    },
    allowCreateEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][2].allow
    },
    allowUpdateEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][1].allow
    },
    allowDeleteEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][3].allow
    },
    allowImportEquipments() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][4].allow
    },
    allowExportEquipments() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][5].allow
    },
    getDotOptions() {
      return [...[{
        value: "",
        text: "",
      }], ...this.docTypeItems?.filter((item) => item.model === this.$route.name || item.model === 'All').map((item) => {
        return {
          value: item.id,
          text: item.type,
        }
      })]
    },
    activeFiltersCount() {
      return Object.keys(this.filterFields).reduce((count, key) => {
        if (key === 'tags' || key === 'division') {
          return count + (this.filterFields[key].length > 0 ? 1 : 0);
        } else if (
          this.filterFields[key] !== '' &&
          this.filterFields[key] !== null && (key !== 'status' ||
            (key === 'status' && (this.filterFields['status'] !== 'Active,Assigned' && this.filterFields['status'] !== 'Inactive'))
          )
        ) {
          return count + 1;
        }
        return count;
      }, 0);
    },
    visibleFields() {
      if (this.$route.name !== "Vehicle") return this.fields.filter(field => field.visible && field.key !== 'current_odometer')
      if (!this.allowUpdateEquipment) return this.fields.filter(field => field.visible && field.key !== 'selected')
      return this.fields.filter(field => field.visible)
    },
    tableKey() {
      return ((this.$route.name || '').toLowerCase()) + 's';
    },
    isDefaultActiveView() {
      const v = this.tableViews[this.activeViewIndex];
      return !v || v.id == null || v.is_default === true;
    },
    contentLoading() {
      // Keep the skeleton until both the tabs (views) and the table data are loaded.
      return !this.isTableMounted || !this.tableViews.length;
    },
    lastDefaultViewIndex() {
      let last = -1;
      this.tableViews.forEach((v, idx) => {
        if (v && (v.id == null || v.is_default === true)) last = idx;
      });
      return last;
    },
    currentColumnsState() {
      const defView = this.tableViews.find(v => v.id == null || v.is_default === true);
      const source = defView && Array.isArray(defView.columns) ? defView.columns : this.fields;
      return (source || []).map(c => ({ key: c.key, visible: !!c.visible }));
    },
    currentFiltersQuery() {
      const parts = [];
      Object.keys(this.filterFields || {}).forEach(key => {
        const val = this.filterFields[key];
        if (val === '' || val === null || val === undefined) return;
        if (Array.isArray(val)) {
          if (val.length === 0) return;
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val.join(','))}`);
        } else {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
        }
      });
      return parts.join('&');
    },
    subTypeOptions() {
      let options = [];
      if (this.$route.name === "Vehicle") {
        options = [
          {
            value: null,
            text: "",
          },
          {
            value: "Truck",
            text: "Truck",
          },
          {
            value: "Semi-Truck",
            text: "Semi-Truck",
          },
          {
            value: "Day-Cab",
            text: "Day-Cab",
          },
          {
            value: "Straight-Truck",
            text: "Straight-Truck",
          },
          {
            value: "Box-Truck",
            text: "Box-Truck",
          },
          {
            value: "Flatbed-Truck",
            text: "Flatbed-Truck",
          },
          {
            value: "Dump-Truck",
            text: "Dump-Truck",
          },
          {
            value: "Refrigerated-Truck",
            text: "Refrigerated-Truck",
          },
          {
            value: "Tow-Truck",
            text: "Tow-Truck",
          },
          {
            value: "Cargo-Van",
            text: "Cargo-Van",
          },
          {
            value: "Van",
            text: "Van",
          },
          {
            value: "Auto",
            text: "Auto",
          },
          {
            value: "SUV",
            text: "SUV",
          },
        ];
      } else if (this.$route.name === "Trailer") {
        options = [
          {
            value: null,
            text: "",
          },
          {
            value: "Dry-Van",
            text: "Dry-Van",
          },
          {
            value: "Dry-Van-Air-Ride",
            text: "Dry-Van-Air-Ride",
          },
          {
            value: "Reefer",
            text: "Reefer",
          },
          {
            value: "Flatbed",
            text: "Flatbed",
          },
          {
            value: "Stepdeck",
            text: "Stepdeck",
          },
          {
            value: "Conestoga",
            text: "Conestoga",
          },
          {
            value: "Conestoga-Drop",
            text: "Conestoga-Drop",
          },
          {
            value: "Double-Drop",
            text: "Double-Drop",
          },
          {
            value: "Gooseneck",
            text: "Gooseneck",
          },
          {
            value: "Tanker",
            text: "Tanker",
          },
          {
            value: "Dump",
            text: "Dump",
          },
          {
            value: "Lowboy",
            text: "Lowboy",
          },
          {
            value: "Auto-Hauler",
            text: "Auto-Hauler",
          },
          {
            value: "Chassis",
            text: "Chassis",
          },
          {
            value: "Container",
            text: "Container",
          },
          {
            value: "Livestock",
            text: "Livestock",
          },
        ];
      }
      return options;
    },
  },
  methods: {
    ...mapActions([
      "getAllEquipments",
      "setNotification",
      "postExcelData",
      "addBulkData",
      "getAllCountries",
      "getAllTags",
      "setLoader",
      "getEquipmentsExportData",
      "updateEquipmentStatus",
      "addBulkEquipmentsDocument",
      "getCustomFields",
      "getTableViews",
      "updateTableView",
      "deleteTableView"
    ]),
    statusDisplay(status) {
      if (status === 'Active') return this.$t('equipmentListPage.statusActive');
      if (status === 'Assigned') return this.$t('equipmentListPage.statusAssigned');
      if (status === 'Inactive') return this.$t('equipmentListPage.statusInactive');
      return status;
    },
    async loadEquipmentCustomFields() {
      try {
        const model = (this.$route.name || '').toLowerCase();
        if (model !== 'vehicle' && model !== 'trailer') return;
        this.clearCustomFieldFilters();
        const list = await this.getCustomFields(model);
        this.equipmentCustomFields = (list || [])
          .filter(f => f.model === model)
          .slice()
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        this.equipmentCustomFields.forEach(f => {
          const key = `cf_${f.id}`;
          if (!Object.prototype.hasOwnProperty.call(this.filterFields, key)) {
            this.$set(this.filterFields, key, '');
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    clearCustomFieldFilters() {
      Object.keys(this.filterFields).forEach(key => {
        if (key.startsWith('cf_')) this.$delete(this.filterFields, key);
      });
      this.equipmentCustomFields = [];
    },
    resetCustomFieldFilters() {
      this.equipmentCustomFields.forEach(f => {
        this.$set(this.filterFields, `cf_${f.id}`, '');
      });
    },
    checkNullValues(payload) {
      let nullKeys = [];
      for (let [key, value] of Object.entries(payload)) {
        if (!value) {
          nullKeys.push(key);
        }
      }
      return nullKeys;
    },
    resetBulkDocFields() {
      if (this.$refs.bulkDocFile) this.$refs.bulkDocFile.value = null;
    },
    async sendDocumentData() {
      try {
        if (this.documentData.description && this.checkDescriptionLength(this.documentData.description)) {
          throw {
            description: [this.$t('equipmentListPage.descriptionMaxLength')],
          };
        }
        const nullKeys = this.checkNullValues({
          date: this.documentData.date,
          document: this.documentData.document,
          ...this.company[0].doc_type ? { doc_type: this.documentData.doc_type } : {}
        });
        if (nullKeys.length === 0) {
          this.setLoader(true);
          let formData = new FormData();
          let fileType = this.documentData.document instanceof File || this.documentData.document instanceof Blob;
          if (!fileType) this.documentData.document = null
          formData.append("equipment_ids", JSON.stringify(this.selectedRows.map((item) => item.id)));
          formData.append(
            "date",
            moment(this.documentData.date).format("YYYY-MM-DD")
          );
          formData.append("type", this.documentData.type);
          formData.append("description", this.documentData.description);
          if (this.documentData.doc_type) formData.append("doc_type", this.documentData.doc_type);
          formData.append("expiry_date", this.documentData.expiry_date ? moment(this.documentData.expiry_date).format("YYYY-MM-DD") : '');
          formData.append(
            "document",
            this.documentData.document
          );
          formData.append("driver", this.documentData.driver);
          formData.append("public", this.documentData.public);
          formData.append("model_type", "equipment");
          formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
          this.documentData = await this.addBulkEquipmentsDocument(
            formData
          );
          await this.setNotification({
            msg: this.$t('equipmentListPage.docAdded'),
            type: "success",
            color: "green",
          });
          await this.getEquipmentData();
          this.$refs.tableRef.clearSelected()
          this.allRowsSelected = false
          this.setLoader(false);
          this.$bvModal.hide("modal-bulk-equipment-docs");
          this.documentData = {
            object_id: null,
            date: null,
            type: null,
            document: null,
            description: null,
            expiry_date: "",
            driver: true,
            public: false,
            doc_type: ""
          };

        }
        else {
          let error = {};
          nullKeys.forEach((x) => {
            error[x] = [this.$t('equipmentListPage.fieldRequired')];
          });
          throw error;
        }
      } catch (error) {
        this.setLoader(false);
        if (typeof error === "object") {
          this.docErrors = error;
        }
      }
    },
    zoom(level) {
      if (!this.panzoom) {
        this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
          maxScale: 5
        })
      }
      level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
    },
    setDocDescription(event) {
      if (event) {
        this.documentData.description = this.getDotOptions.filter((option) => option.value === event)[0].text
      }
      else this.documentData.description = this.defaultDocsData.description
    },
    removeFile() {
      this.docFileName = null;
      this.documentData.document = null
      this.media = null
      this.mediaType = null
    },
    addDocument() {
      this.docFileName = null;
      this.$bvModal.show("modal-bulk-equipment-docs");
      this.documentData = {
        object_id: null,
        date: new Date(),
        type: null,
        document: null,
        expiry_date: "",
        description: null,
        driver: true,
        public: false,
        doc_type: ""
      };
      this.errors = {
        date: null,
        type: null,
        document: null,
        expiry_date: "",
        description: null,
        ...this.company[0].doc_type ? { doc_type: null } : {}
      };
    },
    async getUpdatedFieldsList(updatedFields) {
      this.fields = updatedFields
      await this.persistColumnsForActiveView(updatedFields)
    },
    async loadTableViews() {
      try {
        const data = await this.getTableViews(this.tableKey);
        this.availableColumns = data.available_columns || [];
        this.tableViews = data.views || [];
        // v-tabs reserves index 0 for Add View; real views start at index 1.
        const defaultIndex = this.tableViews.findIndex(v => v.id == null || v.is_default === true);
        const targetIndex = defaultIndex >= 0 ? defaultIndex : 0;
        if (this.activeViewIndex !== targetIndex) {
          this.activeViewIndex = targetIndex;
        } else {
          this.applyActiveView();
        }
      } catch (e) {
        console.log(e);
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('equipmentListPage.failedLoadViews'),
          type: 'error',
          color: 'red',
        });
      }
    },
    applyActiveView() {
      const view = this.tableViews[this.activeViewIndex];
      if (!view) return;
      const ordered = (view.columns || [])
        .filter(c => c && c.visible)
        .slice()
        .sort((a, b) => {
          const ao = a.display_order == null ? -Infinity : a.display_order;
          const bo = b.display_order == null ? -Infinity : b.display_order;
          return ao - bo;
        });
      this.fields = ordered.map(col => ({
        key: col.key,
        label: col.label,
        field: col.field_type === 'dropdown' ? 'Dropdown' : (col.field_type || 'text'),
        visible: true,
        sortable: !!col.sortable,
        disabled: !!col.disabled,
        stickyColumn: !!col.sticky,
        thClass: 'font-table-weight-bold',
        ...(col.key === 'selected' ? { thStyle: { minWidth: '20px', width: '20px' } } : {}),
      }));
      this.activeViewFiltersRaw = view.filters || '';
      this.applyFiltersFromView(view.filters || '');
      this.currentPage = 1;
      this.getEquipmentData();
    },
    applyFiltersFromView(filtersQuery) {
      const blank = {
        search_field: '',
        doc: '',
        tags: [],
        division: [],
        status: this.equipmentType,
      };
      this.equipmentCustomFields.forEach(f => { blank[`cf_${f.id}`] = ''; });
      this.filterFields = blank;
      if (!filtersQuery) return;
      const params = new URLSearchParams(filtersQuery);
      params.forEach((value, key) => {
        if (!(key in this.filterFields)) return;
        if (key === 'tags' || key === 'division') {
          this.filterFields[key] = value ? value.split(',').map(v => isNaN(+v) ? v : +v) : [];
        } else {
          this.filterFields[key] = value;
        }
      });
    },
    openAddView() {
      this.$bvModal.show('modal-add-table-view');
    },
    viewKey(view) {
      if (!view) return '';
      return view.id != null ? `view-${view.id}` : `default-${view.slug || 'default'}`;
    },
    activeView() {
      return this.tableViews[this.activeViewIndex] || null;
    },
    async persistColumnsForActiveView(updatedFields) {
      const view = this.tableViews[this.activeViewIndex];
      if (!view) return;
      const source = updatedFields || this.fields;
      const visibleCols = source.filter(f => !!f.visible);
      const catalogByKey = new Map((this.availableColumns || []).map(c => [c.key, c]));
      const newColumns = visibleCols.map((f, idx) => {
        const meta = catalogByKey.get(f.key) || {};
        return { ...meta, key: f.key, visible: true, display_order: idx };
      });
      this.$set(this.tableViews, this.activeViewIndex, { ...view, columns: newColumns });

      if (this.isDefaultActiveView) return;

      const payload = {
        columns: visibleCols.map((f, idx) => ({ key: f.key, visible: true, display_order: idx + 1 })),
      };
      try {
        const updated = await this.updateTableView({ table: this.tableKey, id: view.id, payload });
        this.$set(this.tableViews, this.activeViewIndex, updated);
      } catch (e) {
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('equipmentListPage.failedSaveCols'),
          type: 'error',
          color: 'red',
        });
      }
    },
    async onFilterModalSave() {
      this.$bvModal.hide('modal-filter');
      if (this.isDefaultActiveView) return;
      await this.persistFiltersForActiveView();
    },
    async persistFiltersForActiveView() {
      const view = this.tableViews[this.activeViewIndex];
      if (!view || view.id == null) return;
      const newFilters = this.currentFiltersQuery || '';
      const payload = { filters: newFilters };
      try {
        const updated = await this.updateTableView({ table: this.tableKey, id: view.id, payload });
        this.$set(this.tableViews, this.activeViewIndex, updated);
        this.activeViewFiltersRaw = updated.filters || '';
      } catch (e) {
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('equipmentListPage.failedSaveFilters'),
          type: 'error',
          color: 'red',
        });
      }
    },
    async onViewCreated(view) {
      await this.loadTableViews();
      let targetIndex = -1;
      if (view && view.id != null) {
        targetIndex = this.tableViews.findIndex(v => v.id === view.id);
      }
      if (targetIndex < 0) targetIndex = this.tableViews.length - 1;
      if (targetIndex < 0) targetIndex = 0;
      const newActive = targetIndex + 1;
      if (this.activeViewIndex !== newActive) {
        this.activeViewIndex = newActive;
      } else {
        this.applyActiveView();
      }
    },
    deleteView() {
      const view = this.tableViews[this.activeViewIndex];
      if (!view || view.id == null || view.is_default === true) return;
      this.showDeleteViewModal = true;
    },
    async confirmDeleteView(status) {
      if (!status) {
        this.showDeleteViewModal = false;
        return;
      }
      const view = this.tableViews[this.activeViewIndex];
      if (!view || view.id == null) {
        this.showDeleteViewModal = false;
        return;
      }
      try {
        this.setLoader(true);
        await this.deleteTableView({ table: this.tableKey, id: view.id });
        await this.setNotification({
          msg: this.$t('equipmentListPage.viewDeleted', { name: view.name }),
          type: 'success',
          color: 'green',
        });
        this.showDeleteViewModal = false;
        await this.loadTableViews();
        const defaultIndex = this.tableViews.findIndex(v => v.id == null || v.is_default === true);
        const targetIndex = defaultIndex >= 0 ? defaultIndex : 0;
        if (this.activeViewIndex !== targetIndex) {
          this.activeViewIndex = targetIndex;
        } else {
          this.applyActiveView();
        }
        this.setLoader(false);
      } catch (e) {
        this.setLoader(false);
        this.showDeleteViewModal = false;
        await this.setNotification({
          msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('equipmentListPage.failedDeleteView'),
          type: 'error',
          color: 'red',
        });
      }
    },
    changeEquipmentStatusItem(item) {
      if (item) {
        this.changeEquipmentStatus()
      }
      this.showDeactivateModal = false
    },
    async changeEquipmentStatus() {
      try {
        this.setLoader(true)
        await this.updateEquipmentStatus({
          action: this.equipmentType === 'Inactive' ? 'activate' : 'deactivate',
          equipment_ids: this.selectedRows.map((data) => data.id)
        })
        await this.setNotification({
          msg: this.equipmentType === 'Inactive' ? this.$t('equipmentListPage.equipmentsActivated') : this.$t('equipmentListPage.equipmentsDeactivated'),
          type: "success",
          color: "green",
        });
        this.$refs.tableRef.clearSelected()
        await this.getEquipmentData()
        this.setLoader(false)
      }
      catch (e) {
        this.setLoader(false)
        console.log(e)
      }
    },
    checked(index, checked) {
      let tableRef = this.$refs.tableRef
      if (checked === true) tableRef.selectRow(index)
      else tableRef.unselectRow(index)
    },
    onRowSelected(items) {
      this.selectedRows = items
    },
    selectRows(checked) {
      if (checked) {
        this.$refs.tableRef.selectAllRows()
      }
      else {
        this.$refs.tableRef.clearSelected()
        this.allRowsSelected = false
      }
    },
    async setEquipmentType(type = "") {
      this.equipmentType = type
      this.currentPage = 1
      this.resetFilterFields()
    },
    async getEquipmentNewData(id = null) {
      this.allowAddEquipment = false
      await this.getEquipmentData()
      if (id) {
        this.equipmentID = id
        this.setNotesSection = false
      }
    },
    async resetFilterFields() {
      this.filterFields = {
        search_field: '',
        doc: '',
        type: '',
        division: [],
        tags: [],
        status: this.equipmentType
      }
      this.resetCustomFieldFilters()
      if (!this.isDefaultActiveView) {
        await this.persistFiltersForActiveView();
      }
      await this.getEquipmentData();
    },
    resetEquipmentList() {
      this.equipmentID = ""
      this.setNotesSection = false
      this.getEquipmentData()
    },
    setEquipmentData(id) {
      this.equipmentID = id
      this.setNotesSection = false
    },
    showNotesSection(id) {
      if (this.allowUpdateEquipment || this.allowViewEquipment) {
        this.equipmentID = id
        this.setNotesSection = true
      }
    },
    async updateFields(updatedFields) {
      this.fields = updatedFields
      await this.persistColumnsForActiveView(updatedFields)
    },
    async resetTableFields() {
      this.showColumns = false;
      if (this.isDefaultActiveView) {
        await this.loadTableViews();
        return;
      }
      const defaultView = this.tableViews.find(v => v && (v.id == null || v.is_default === true));
      if (!defaultView || !Array.isArray(defaultView.columns)) return;
      const defaultCols = defaultView.columns
        .slice()
        .sort((a, b) => {
          const ao = a.display_order == null ? -Infinity : a.display_order;
          const bo = b.display_order == null ? -Infinity : b.display_order;
          return ao - bo;
        });
      const catalogByKey = new Map((this.availableColumns || []).map(c => [c.key, c]));
      const newFields = defaultCols
        .filter(c => !!c.visible)
        .map(col => {
          const meta = catalogByKey.get(col.key) || {};
          return {
            key: col.key,
            label: meta.label || col.label,
            field: (meta.field_type || col.field_type) === 'dropdown' ? 'Dropdown' : (meta.field_type || col.field_type || 'text'),
            visible: true,
            sortable: !!(meta.sortable ?? col.sortable),
            disabled: !!(meta.disabled ?? col.disabled),
            stickyColumn: !!(meta.sticky ?? col.sticky),
            thClass: 'font-table-weight-bold',
            ...(col.key === 'selected' ? { thStyle: { minWidth: '20px', width: '20px' } } : {}),
          };
        });
      this.fields = newFields;
      await this.persistColumnsForActiveView(newFields);
    },
    async bulkUploadEquipment() {
      if (this.document) {
        this.setLoader(true)
        this.errors = {
          document: null,
        };
        try {
          let formData = new FormData();
          formData.append("file", this.document);
          formData.append("target_table", "Equipment");
          formData.append("equipment_type", this.$route.name);
          formData.append("company_id", this.userCompany)
          const newEquipments = await this.addBulkData(formData);
          if (newEquipments) {
            await this.getEquipmentData();
            await this.setNotification({
              msg: this.$t('equipmentListPage.importSuccess'),
              type: "success",
              color: "green",
            });
            this.$bvModal.hide("modal-bulk-upload");
            this.setLoader(false)
          }
        } catch (e) {
          this.setLoader(false)
          if (typeof e === 'object' && e !== null) {
            // Parse row errors from the response
            this.bulkUploadErrors = [];
            this.bulkUploadSummary = e.summary || '';
            Object.keys(e).forEach((key) => {
              if (key.startsWith('row no:')) {
                this.bulkUploadErrors.push({
                  row: key,
                  message: e[key]
                });
              }
            });
            if (this.bulkUploadErrors.length > 0) {
              this.$bvModal.hide('modal-bulk-upload');
              this.$bvModal.show('modal-bulk-upload-errors');
            } else {
              await this.setNotification({
                msg: this.$t('equipmentListPage.csvErrors'),
                type: "error",
                color: "red",
              });
            }
          } else {
            await this.setNotification({
              msg: "The Uploaded CSV has Wrong/Missing Fields.",
              type: "error",
              color: "red",
            });
          }
        }
      } else {
        this.errors = {
          document: this.$t('equipmentListPage.fieldRequired'),
        };
      }
    },
    resetField() {
      this.$refs.docFile.value = null;
      this.fileName = null;
      this.document = null;
      this.errors = {
        document: null,
      };
    },
    handleFileUpload() {
      this.document = this.$refs.docFile.files[0];
      this.fileName = this.document.name;
    },
    handleBulkFileUpload() {
      this.documentData.document = this.$refs.bulkDocFile.files[0];
      this.docFileName = this.documentData.document.name;
      this.media = URL.createObjectURL(this.documentData.document);
      if (this.$refs.bulkDocFile.files[0].type.includes('pdf')) this.mediaType = 'pdf'
      else this.mediaType = 'image'
    },
    async downloadExcel() {
      try {
        this.setLoader(true)
        let url = ""
        Object.keys(this.filterFields).map((key) => {
          if (this.filterFields[key] !== '' && key != 'tags' && key != 'division') {
            if (key !== 'search_field') url += `${key}=${this.filterFields[key]}&`
            else {
              let searchList = ""
              if (this.fields.length > 0) this.fields.filter((item) => item.visible && item.field === 'text').map(({ key }, index) => index === 0 ? searchList = key : searchList += ',' + key)
              else searchList = 'unit_no,vin_no'
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&search_list=${searchList}&`
            }
          }
          else if ((key === "tags" || key === "division") && this.filterFields[key].length > 0) url += `${key}=${encodeURIComponent(this.filterFields[key].join(','))}&`
        })
        if (this.sortBy) {
          url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
        }
        else {
          url += `sort_field=unit_no&sort_order=asc&`
        }
        url += `type=${this.$route.name}`
        if (this.activeViewFiltersRaw) {
          // Keys the user can clear from the filter modal are authoritative — don't
          // backfill them from the saved view (otherwise a cleared filter snaps back).
          const userControlledKeys = new Set(Object.keys(this.filterFields || {}));
          const existingKeys = new Set();
          url.split('&').forEach(part => {
            const eq = part.indexOf('=');
            if (eq > 0) existingKeys.add(part.slice(0, eq));
          });
          const viewParams = new URLSearchParams(this.activeViewFiltersRaw);
          viewParams.forEach((value, key) => {
            if (existingKeys.has(key) || userControlledKeys.has(key)) return;
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          });
        }
        const { excel_file } = await this.getEquipmentsExportData(url)
        window.open(process.env.VUE_APP_API_URL + excel_file, "_blank");
        await this.setNotification({
          msg: this.$t('equipmentListPage.fileExported'),
          type: "success",
          color: "green",
        });
        this.setLoader(false)
      }
      catch (e) {
        console.log(e)
        this.setLoader(false)
      }
    },
    checkTableField(key) {
      return this.fields.filter((item) => item.key === key)[0]?.visible
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async getEquipmentData() {
      try {
        this.isBusy = true
        let url = ""
        let tags = ""
        if(!this.isTableMounted && this.$route.query.unitNo){
          this.filterFields.search_field = this.$route.query.unitNo
          if(this.$route.query.id) this.setEquipmentData(this.$route.query.id)
        }
        Object.keys(this.filterFields).map((key) => {
          if (this.filterFields[key] && key != 'tags') {
            if (key !== 'search_field') url += `${key}=${this.filterFields[key]}&`
            else {
              let searchList = ""
              if(this.fields.length > 0) this.fields.filter((item) => item.visible && item.field === 'text').map(({ key }, index) => index === 0 ? searchList = key : searchList += ',' + key)
              else searchList = 'unit_no,vin_no'
              url += `${key}=${encodeURIComponent(this.filterFields[key])}&search_list=${searchList}&`
            }
          }
          else if (key === "tags" && this.filterFields[key].length > 0) {
            this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
            url += `${key}=${encodeURIComponent(tags)}&`
          }
        })
        if (this.sortBy) {
          url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
        }
        else {
          url += `sort_field=unit_no&sort_order=asc&`
        }
        url += `type=${this.$route.name}&`
        url += `page=${this.currentPage}&page_size=${this.perPage}`
        if (this.activeViewFiltersRaw) {
          // Keys the user can clear from the filter modal are authoritative — don't
          // backfill them from the saved view (otherwise a cleared filter snaps back).
          const userControlledKeys = new Set(Object.keys(this.filterFields || {}));
          const existingKeys = new Set();
          url.split('&').forEach(part => {
            const eq = part.indexOf('=');
            if (eq > 0) existingKeys.add(part.slice(0, eq));
          });
          const viewParams = new URLSearchParams(this.activeViewFiltersRaw);
          viewParams.forEach((value, key) => {
            if (existingKeys.has(key) || userControlledKeys.has(key)) return;
            url += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          });
        }
        const data = await this.getAllEquipments(url);
        if (this.isDefaultActiveView) {
        this.activeCount = data.total_active_count >= 0 ? data.total_active_count : 0
        this.inactiveCount = data.total_inactive_count >= 0 ? data.total_inactive_count : 0
        }
        if (data.total_entries) {
          this.rows = data.total_entries
          const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
          const end = this.perPage * (this.currentPage - 1) + data.queryset_count
          this.positionText = this.$t('equipmentListPage.positionText', { start, end, total: data.total_entries })
        }
        else {
          this.rows = 0
          this.positionText = this.$t('equipmentListPage.emptyPosition')
        }
        this.items = [];
        this.allEquipments.forEach((equip) => {
          let color;
          if (equip.docs.length === 0) {
            color = "background:#C4C4C4";
          }
          else if (equip.docs.filter((item) => item.expiry_date && parseInt((new Date(item.expiry_date) - new Date()) / (1000 * 60 * 60 * 24), 10) <= 0).length) {
            color = "background:#FF0000";
          }
          else if (equip.docs.filter((item) => item.expiry_date && parseInt((new Date(item.expiry_date) - new Date()) / (1000 * 60 * 60 * 24), 10) <= 31 && parseInt((new Date(item.expiry_date) - new Date()) / (1000 * 60 * 60 * 24), 10) >= 1).length) {
            color = "background:#FFC800";
          }
          else {
            color = "background:#2CCE89";
          }
           const customFieldData = { custom: {} }
            if (Array.isArray(equip.custom_fields)) {
              equip.custom_fields.forEach((field) => {
                const matchedField = this.equipmentCustomFields.find((f) => f.id === field.id)
                if (matchedField) {
                  let v = matchedField.field_type === 'date'
                    ? (field.value ? moment(field.value).format("ll") : '')
                    : field.value;
                  if (Array.isArray(v)) v = v.length ? v.join(', ') : '-';
                  customFieldData.custom[matchedField.id] = (v != null && v !== '') ? String(v) : '-';
                }
              })
            }

          this.items.push({
            id: equip.id,
            unit_no: equip.unit_no,
            Expiry: equip.inactivate_date,
            type: equip.type,
            subtype: equip.subtype ? equip.subtype : '-',
            num_docs: equip.docs.length,
            vin_no: equip.vin_no ? equip.vin_no : '-',
            year: equip.year,
            make: equip.make ? equip.make : '-',
            model: equip.model ? equip.model : '-',
            plate_no: equip.plate_no ? equip.plate_no : '-',
            plate_state: equip.state?.name,
            current_odometer: equip.current_odometer,
            driver: equip.driver
              ? equip.driver["first_name"] + " " + equip.driver["last_name"]
              : "-",
            status: equip.status,
            value: equip.value ? equip.value : '-',
            dispatch_group1: equip.dispatch_group1,
            dispatch_group2: equip.dispatch_group2,
            serial_number: equip.serial_number ? equip.serial_number : '-',
            Tags: equip.tags,
            color,
            tags: equip.tags.map((tag) => tag.add_tag),
            active_date: equip.active_date ? moment(equip.active_date).format("ll") : '-',
            inactivate_date: equip.inactivate_date ? moment(equip.inactivate_date).format("ll") : '-',
            notes: equip.notes ? equip.notes : null,
            division: equip.division_read ? equip.division_read.division : '-',
            integration: equip.geo_tab_id ? true : equip.ps_id ? true: equip.samsara_id ? true : equip.motive_id ? true : equip.LT_id ? true : false,
            ...customFieldData
          });
        });
        if (this.items.length === 0) this.emptyTable = true
        else this.emptyTable = false
        this.isBusy = false
        this.isTableMounted = true
      }
      catch (e) {
        this.isBusy = false
        this.isTableMounted = true
        console.log(e)
      }
    },
    async getCountries(item) {
      await this.getAllCountries();
      this.countries = this.allCountries.map((item) => ({
        id: item.id,
        label: item.name,
      }));
      this.getStates(this.countries[0], item);
    },
    getStates(selectedOption, item) {
      this.states = this.allCountries
        .filter((country) => country.id === selectedOption.id)[0]
        .state.map((item) => ({
          id: item.id,
          label: item.name,
        }));
      if (this.states.length === 0) {
        this.newEquipment.state.id = null;
      } else {
        if (this.newEquipment.state && item) {
          this.newEquipment.state.id = item;
        } else if (this.newEquipment.state) {
          this.newEquipment.state.id = this.states.filter(
            (state) => state.label === "-"
          )[0].id;
        }
      }
    },
    getCountryName(id) {
      return this.allCountries.filter((item) => item.id === id)[0].name;
    },
  },
  watch: {
    activeViewIndex(newVal, oldVal) {
      if (newVal >= 0 && newVal < this.tableViews.length) {
        this.applyActiveView();
      } else if (this.tableViews.length) {
        // v-tabs landed on the Add View pseudo-tab — snap back to the previous real view.
        const fallback = (oldVal >= 0 && oldVal < this.tableViews.length) ? oldVal : 0;
        this.$nextTick(() => { this.activeViewIndex = fallback; });
      }
    },
    perPage: {
      async handler() {
        await this.getEquipmentData();
      },
      immediate: true,
    },
    currentPage: {
      async handler() {
        await this.getEquipmentData();
      },
    },
    sortBy: {
      async handler() {
        await this.getEquipmentData();
      },
    },
    sortDesc: {
      async handler() {
        await this.getEquipmentData();
      },
    },
    filterFields: {
      handler() {
        this.currentPage = 1
      },
      deep: true
    },
    '$route.name': {
      async handler() {
        await this.loadEquipmentCustomFields();
        await this.loadTableViews();
      }
    },
    company: {
      async handler() {
        await this.getAllTags(this.userCompany);
        // this.dispatchGroups.map((item) => {
        //   this.equipmentDispatchGroups.push({
        //     id: item.id,
        //     label: item.name,
        //   });
        // });
        this.tags.map((item) => {
          this.allTags.push({
            id: item.add_tag,
            label: item.add_tag,
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    try {
      await this.getCountries(this.newEquipment.state.id);
      await this.loadEquipmentCustomFields();
      await this.loadTableViews();
    } catch (error) {
      await this.setNotification({
        msg: error,
        type: "error",
        color: "red",
      });
    }
  },
};
</script>

<style>
/* .equipment-border{
        border-bottom: 1px solid rgba(0 0 0 / 10%);
    } */
.equipment {
  background-color: var(--btn-bg-color) !important;
}

.inactive-equipment {
  background-color: #F4F4F4 !important;
  color: black !important;
  border: 1px solid #EAEAEA;
}

.assigned-equipment {
  background-color: var(--bg-green) !important;
  color: white !important;
}

.modal-header {
  background-color: #fff;
  color: black;
  padding: 1rem !important;
}

.modal-header h5 {
  color: black !important
}

.modal-title {
  font-size: 18px;
}

.close {
  background: none;
  color: #fff;
  font-size: 16px;
}

.modal .col-form-label {
  color: var(--black);
  opacity: 1;
  text-transform: capitalize;
}

.modal-body label {
  font-size: var(--small);
  color: var(--black);
}

.unit.form-control,
.v-select.vs--searchable,
.unit.form-control:focus {
  background: #fafafa !important;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  font-size: 12px;
}

.v-select .vs__dropdown-toggle {
  border: none !important;
}

.modal-footer .cancel {
  background-color: #F4F4F4;
  color: var(--black);
  font-size: 16px;
  width: 100px !important;
  height: 40px;
}

.modal-footer .cancel.w-150px {
  width: 150px !important;
}

.modal-footer .cancel:hover,
.modal-footer .cancel:focus,
.modal-footer .cancel:active {
  background-color: #dddddd;
  color: var(--black);
}

.modal-footer .save {
  background-color: var(--btn-bg-color) !important;
  color: #fff;
  font-size: 16px;
  width: 100px !important;
  height: 40px;
}

.modal-footer .w-150px .save.w-100 {
  width: 100% !important;
}

.modal-footer .save.w-fit-content {
  width: fit-content !important;
}

.modal-footer .save.danger-btn {
  background-color: var(--danger-color) !important;
  color: white !important
}

.modal-footer .save:hover,
.modal-footer .save:focus,
.modal-footer .save:active {
  background-color: var(--btn-bg-color);
}

.custom-select {
  background: #ffffff;
  border: 1px solid #dee2e6;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: -webkit-fill-available;
  height: 40px;
  font-size: 14px;
  padding-left: 10px;
}

.custom-select:focus-visible,
.custom-select:active {
  box-shadow: unset !important;
}

.equipment-list-page .select_arrow {
  position: relative;
}

.equipment-list-page .select_arrow svg {
  position: absolute;
  top: 40px;
  right: 10px;
}

.w-equipment-box>div>div>div {
  min-height: 40px !important;
  height: auto !important;
}

.table-columns-section .btn.btn-table-columns-section {
  height: 40px !important;
}

.table-columns-section {
  margin-top: 0rem !important;
}

.filter-section ul {
  width: 240px;
  min-width: 100% !important;
  padding-bottom: 0px !important
}

.filter-section-items {
  width: 190px;
  margin: 0 auto;
}

.filter-section .dropdown-menu.show {
  transform: translate3d(-185px, 40px, 0px) !important
}


.table-columns-dropdown .checkbox-section>div>div,
.table-columns-dropdown .checkbox-section .heading {
  padding: 0px 25px;
}

.table-columns-dropdown .checkbox-section>div>div .custom-control {
  padding-left: 0rem !important;
}

.table-columns-dropdown .checkbox-section {
  height: 380px;
  overflow-y: auto;
}

.table-columns-dropdown .buttons-section {
  border-radius: 0px 0px 5px 5px;
  border-top: 1px solid #EAEAEA;
  background: #FFF;
  padding: 23px 27px;
}

.ghost {
  opacity: 0.5;
  background: #e9e9e9 !important;
  height: 30px;
}

.docs-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  color: white;
  align-items: center;
}

.filter-box>div .search-field {
  width: 335px !important;
}

.equipment-table-section {
  border-radius: 10px;
  border: 1px solid #EAEAEA;
  padding: 16px 25px;
}

.equipment-table-section>table>thead>tr>th {
  border: none !important
}

.ml-1 {
  margin-left: 0.1rem !important;
}

.w-150px {
  width: 150px !important;
}

@media (max-width: 575px) {
  .filter-box>div .search-field, .filter-box>div>fieldset {
    width: 100% !important;
    margin-right: 0px !important;
  }
}
</style>
